export const TransactionType = {
	TOAST: "toast"
}